import { StyleSheet, View } from 'react-native'
import { colorList } from 'utils/colors'
import Text from 'theme/Text'
import React from 'react'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import i18n from 'utils/i18n'

const LunchScannerInstructions = ({ compact = false }) => {
	return (
		<View style={ styles.container }>
			<View accessible={ false } style={ styles.illustration }>
				<Icon icon={ IconSystemConstants.QRCODE } size={ compact ? 48 : 80 } color={ colorList.PRIMARY.primary } />
			</View>
			<Text style={ [ styles.title, compact && styles.titleCompact ] }>{ i18n.t( 'lunch_scanner.index.instructions' ) }</Text>
			<Text style={ styles.hint }>{ i18n.t( 'lunch_scanner.index.scan_hint' ) }</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		maxWidth: 560,
		alignSelf: 'center',
		alignItems: 'center',
		padding: 20,
		gap: 20,
	},
	illustration: {
		padding: 20,
		borderRadius: 24,
		backgroundColor: colorList.ORANGE.subtle,
	},
	title: {
		fontSize: 28,
		fontWeight: '700',
		textAlign: 'center',
	},
	titleCompact: { fontSize: 20 },
	hint: {
		fontSize: 16,
		textAlign: 'center',
	},
});

export default LunchScannerInstructions;
